<div id="shell-loading" [hidden]="!doingStuff">
  <div class="page-loading-spinner">
    <img src="assets/images/logo-circle.png" class="loading-flash" width="100" alt="Loading" />
    <h3>Loading</h3>
    <small>Please wait</small>
  </div>
</div>

<ng-container *ngIf="!doingStuff">
  <mat-toolbar class="topbar">
    <button *ngIf="!isSidenavPinned" mat-icon-button id="menu-button" (click)="toggleSidenav()">
      <mat-icon>menu</mat-icon>
    </button>
    <img *ngIf="light" src="assets/images/CristieSoftware_logo.png" alt="Cristie Logo" id="logotrans" />
    <img *ngIf="!light && !classic" src="assets/images/cristie_trans.png" alt="Cristie Logo" id="logotrans" />
    <img *ngIf="classic" src="assets/images/classic-logo.png" alt="Cristie Logo" id="logotrans" />
    <span class="spacer"></span>

    <section [matMenuTriggerFor]="userMenu" id="user-menu-trigger">
      <small class="userText" id="current-user">
        {{shellService.currentUser?.username}}
        <mat-icon class="icon-align">expand_more</mat-icon>
      </small>
      <mat-menu #userMenu yPosition="below" panelClass="user-menu-panel">
        <button mat-menu-item id="dark-theme-button" (click)="setTheme('dark')">Dark theme</button>
        <button mat-menu-item id="light-theme-button" (click)="setTheme('light')">Light theme</button>
        <button mat-menu-item id="midnight-theme-button" (click)="setTheme('midnight')">Midnight theme</button>
        <mat-divider></mat-divider>
        <button mat-menu-item id="logout-button" (click)="logout()">Logout</button>
      </mat-menu>
    </section>
  </mat-toolbar>

  <mat-sidenav-container [class.nav-pinned]="isSidenavPinned">
    <mat-sidenav #sidenav [mode]="isSidenavPinned ? 'side' : 'over'" [opened]="isSidenavPinned"
      [disableClose]="isSidenavPinned" role="navigation" position="start">
      <mat-nav-list role="navigation" class="main-menu">
        <div class="main-menu-contract-select" *ngIf="!isTrialUser && shellService.contracts?.length">
          <mat-form-field appearance="fill" class="nav-contract-select">
            <mat-label>Contract</mat-label>
            <mat-select id="global-contract-select" [value]="shellService.selectedContract?.id"
              (selectionChange)="changeContract($event.value)">
              <mat-option *ngFor="let contract of shellService.contracts" [value]="contract.id">
                {{ contract.id }} ({{ contract.displayName }})<span *ngIf="!contract.active"> (expired)</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-accordion>
          <mat-expansion-panel id="portal-nav-panel" *ngIf="!isTrialUser">
            <mat-expansion-panel-header>
              <mat-panel-title class="nav-item-link">
                <mat-icon>key</mat-icon>Licenses
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item id="portal-view-nav" (click)="closeNavAfterRoute()" routerLink="/licenses"
                [queryParams]="{tab: 'view'}" class="nav-item-link">View Licenses</mat-list-item>
              <mat-list-item *ngIf="canActivateLicences" id="portal-activate-nav" (click)="closeNavAfterRoute()"
                routerLink="/licenses" [queryParams]="{tab: 'activate'}" class="nav-item-link">Activate
                Licenses</mat-list-item>
              <mat-list-item *ngIf="canSurrenderLicences" id="portal-surrender-nav" (click)="closeNavAfterRoute()"
                routerLink="/licenses" [queryParams]="{tab: 'surrender'}" class="nav-item-link">Surrender
                Licenses</mat-list-item>
              <mat-list-item *ngIf="canSurrenderLicences" id="portal-offline-surrender-nav"
                (click)="closeNavAfterRoute()" routerLink="/licenses" [queryParams]="{tab: 'offline-surrender'}"
                class="nav-item-link">Offline Surrender</mat-list-item>
              <mat-list-item *ngIf="canRequestTokens" id="portal-tokens-nav" (click)="closeNavAfterRoute()"
                routerLink="/licenses" [queryParams]="{tab: 'request-tokens'}" class="nav-item-link">Request
                Tokens</mat-list-item>
              <mat-list-item id="portal-activity-nav" (click)="closeNavAfterRoute()" routerLink="/licenses"
                [queryParams]="{tab: 'activity'}" class="nav-item-link">Activity Log</mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel id="downloads-nav-panel">
            <mat-expansion-panel-header>
              <mat-panel-title class="nav-item-link">
                <mat-icon>download</mat-icon>Downloads
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item id="downloads-latest-nav" (click)="closeNavAfterRoute()" routerLink="/downloads"
                [queryParams]="{tab: 'latest'}" class="nav-item-link">Latest Downloads</mat-list-item>
              <mat-list-item id="downloads-vault-nav" (click)="closeNavAfterRoute()" routerLink="/downloads"
                [queryParams]="{tab: 'archived'}" class="nav-item-link">Vault</mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel id="account-nav-panel">
            <mat-expansion-panel-header>
              <mat-panel-title class="nav-item-link">
                <mat-icon>person</mat-icon>My Account
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item *ngIf="!isTrialUser" id="account-details-nav" (click)="closeNavAfterRoute()" routerLink="/account"
                [queryParams]="{tab: 'details'}" class="nav-item-link">Account Details</mat-list-item>
              <mat-list-item *ngIf="!isTrialUser" id="account-contracts-nav" (click)="closeNavAfterRoute()" routerLink="/account"
                [queryParams]="{tab: 'contracts'}" class="nav-item-link">Add Contracts</mat-list-item>
              <mat-list-item *ngIf="!isTrialUser" id="account-invite-users-nav" (click)="closeNavAfterRoute()" routerLink="/account"
                [queryParams]="{tab: 'invite-users'}" class="nav-item-link">Invite Users</mat-list-item>
              <mat-list-item *ngIf="!isTrialUser" id="account-reset-question-nav" (click)="closeNavAfterRoute()" routerLink="/account"
                [queryParams]="{tab: 'reset-question'}" class="nav-item-link">Update Reset Question</mat-list-item>
              <mat-list-item *ngIf="!isTrialUser" id="account-password-nav" (click)="closeNavAfterRoute()" routerLink="/account"
                [queryParams]="{tab: 'password'}" class="nav-item-link">Change Password</mat-list-item>
              <mat-list-item *ngIf="!isTrialUser" id="account-delete-nav" (click)="closeNavAfterRoute()" routerLink="/account"
                [queryParams]="{tab: 'delete'}" class="nav-item-link">Delete Account</mat-list-item>
              <mat-list-item id="logout-button" class="nav-item-link" (click)="logout()">Logout</mat-list-item>
            </mat-list>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-nav-list>

      <div class="main-menu-copyright">
        <mat-divider></mat-divider>
        <div class="main-menu-copyright-container">
          <div class="main-menu-copyright-text">
            © Cristie Software {{ year }}<br>
            v{{ version }}
          </div>
          <button mat-icon-button id="pin-menu-button" (click)="toggleSidenavPin()"
            [matTooltip]="isSidenavPinned ? 'Unpin menu' : 'Pin menu'">
            <mat-icon [class.unpinned]="!isSidenavPinned">push_pin</mat-icon>
          </button>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
